import { Track } from '@1debit/analytics';

import { analyticsHandler } from 'utils/eventRouter';
import { IS_PRELOAD } from 'utils/queryParamHelpers';
import { page } from 'utils/segment/doSegmentCalls';

export function trackEnrollmentPendingPageViewed() {
  page('Enrollment Pending', { current_url: window.location.href });

  analyticsHandler.trackPage('enrollment_pending');
}

export function trackEnrollmentDeclinePageViewed() {
  page('Enrollment Declined', { current_url: window.location.href });

  analyticsHandler.trackPage('enrollment_declined');
}

export function sendSuccessPageView() {
  page('Success', {}, false);

  analyticsHandler.trackPage('success');
}

export function accountPageView(isReferralFlow) {
  const trackPage = () => {
    if (IS_PRELOAD) return;

    page(isReferralFlow ? 'Referral Account Page' : 'Account Page', {
      prerendering: window.prerendering,
    });

    analyticsHandler.trackPage(
      isReferralFlow ? 'referral_account_page' : 'account_page',
      null,
      {
        first_contentful_paint: window.fcp,
        largest_contentful_paint: window.lcp,
      }
    );
  };

  // Track the page when the page is not prerendering in the background anymore
  if (document.prerendering) {
    document.addEventListener('prerenderingchange', trackPage, { once: true });
  } else {
    trackPage();
  }
}

export function productPickerPageView() {
  page('Product Picker Page');

  analyticsHandler.trackPage('product_picker_page');
}

export function activityPageView() {
  page('Activity Page');

  analyticsHandler.trackPage('activity_page');
}

export function addressPageView() {
  page('Address Page');

  analyticsHandler.trackPage('address_page');
}

export function birthDatePageView() {
  page('Date of Birth Page');

  analyticsHandler.trackPage('date_of_birth_page');
}

export function creditDayZeroTermsPageView() {
  page('Credit Day Zero Terms of Service Page');

  analyticsHandler.trackPage('credit_day_zero_terms_of_service_page');
}

export function verifyEmailPageView() {
  page('Verify Email Page');

  analyticsHandler.trackPage('verify_email_page');
}

export function passwordPageView() {
  page('Password Page');

  analyticsHandler.trackPage('password_page');
}

export function phonePageView() {
  page('Phone Page');

  analyticsHandler.trackPage('phone_page');
}

export function verifyPhonePageView() {
  page('Verify Phone Page');

  analyticsHandler.trackPage('verify_phone_page');
}

export function ssnPageView() {
  page('Social Security Number Page');

  analyticsHandler.trackPage('social_security_number_page');
}

export function firstPageView() {
  page('First Page Viewed', {
    starting_point: 'Direct to Enrollment',
  });

  analyticsHandler.trackEvent(Track.WebActionTriggered, {
    unique_id: 'first_entry_point',
  });
}

export function reviewNamePage() {
  page('Review Name Page');

  analyticsHandler.trackPage('review_name_page');
}

export function reviewDateOfBirthPage() {
  page('Review Date of Birth Page');

  analyticsHandler.trackPage('review_date_of_birth_page');
}

export function reviewAddressPage() {
  page('Review Address Page');

  analyticsHandler.trackPage('review_address_page');
}

export function reviewSsnPage() {
  page('Review Social Security Number Page');

  analyticsHandler.trackPage('review_social_security_number_page');
}

export function reviewIntroPage() {
  page('Review Intro Page');

  analyticsHandler.trackPage('review_intro_page');
}

export function p2pAccountPage() {
  page('P2P Account Page');

  analyticsHandler.trackPage('p2p_account_page');
}

export function p2pIdentityPage() {
  page('P2P Identity Page');

  analyticsHandler.trackPage('p2p_identity_page');
}

export function p2pActivityPage() {
  page('P2P Activity Page');

  analyticsHandler.trackPage('p2p_activity_page');
}

export function alreadyHasActiveAccountPageView() {
  page('Already Has Active Account Page');

  analyticsHandler.trackPage('already_has_active_account_page');
}

export function prefillConfirmationPageView() {
  page('Prefill Confirmation Page');

  analyticsHandler.trackPage('prefill_confirmation_page');
}

export function prefillTrustNextPageView(eventProperties) {
  page('SUP Verified Next Page', eventProperties, true);

  analyticsHandler.trackPage('sup_verified_next_page');
}

export function personalInfoPageView(flow) {
  page(`${flow} Personal Info Page`);

  analyticsHandler.trackPage(`${flow}_personal_info_page`);
}

export function phoneVerificationPageView(flow) {
  page(`${flow} Personal Info Verify Phone Page`);

  analyticsHandler.trackPage(`${flow}_personal_info_verify_phone_page`);
}
